module.exports = __webpack_public_path__ + "img/travessia_logo.591bcabe.png";